import { _js } from '@ifixit/utils/localize';
import { cn } from '@ifixit/ui/lib/utils';
import { useEditorContext } from '../editor_context';
import type { CustomCharacterCountStorage } from '../extensions/custom_character_count';

export const CharacterCount = () => {
   const { editor } = useEditorContext();

   if (!editor || editor.isDestroyed) {
      return null;
   }

   const characterCount = editor.storage.characterCount as CustomCharacterCountStorage;
   const { minCharacters, maxCharacters } = characterCount;

   const charCount = characterCount.characters();
   const tooShort = charCount < minCharacters;
   const tooLong = charCount > maxCharacters;
   const charsLeft = maxCharacters - charCount;

   let charCountText = String(charsLeft);

   if (tooShort) {
      /* Translators: %1 -> number of characters; */
      charCountText = _js('%1 too short', String(minCharacters - charCount));
   } else if (tooLong) {
      /* Translators: %1 -> number of characters; */
      charCountText = _js('%1 too long', String(Math.abs(charsLeft)));
   }

   // -mt-6/ml-2 move this to the bottom left corner of the editor div
   return (
      <p
         className={cn(
            'absolute z-[2] -mt-6 ml-2',
            tooShort || tooLong ? 'font-bold text-red-600' : 'text-gray-400'
         )}
      >
         {charCountText}
      </p>
   );
};
